import { render, staticRenderFns } from "./SurveyList.vue?vue&type=template&id=23420656&scoped=true"
import script from "./SurveyList.vue?vue&type=script&lang=js"
export * from "./SurveyList.vue?vue&type=script&lang=js"
import style0 from "./SurveyList.vue?vue&type=style&index=0&id=23420656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23420656",
  null
  
)

export default component.exports